
import React, { createContext, useContext, useState, useEffect } from 'react';
import { postData, fetchData } from '../common/Api';
import { useSubscription } from './SubscriptionsProvider';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const { setActivePlan } = useSubscription();

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === 'true' || false;
  });

  const [sessionId, setSessionId] = useState(() => {
    return localStorage.getItem("sessionId") || '';
  });

  const [expiresAt, setExpiresAt] = useState(() => {
    return localStorage.getItem("expiresAt") || null;
  });

  const getSessionDetails = async () => {
    try{
      const response = await fetchData(`/api/v1/session/${sessionId}`);
      const expirationUTC = new Date(response.data.expiresAt);
      setExpiresAt(expirationUTC);
    } catch (error) {
      if (error.status === 404 || error.status === 401){
        setIsAuthenticated(false);
        setSessionId('');
        setExpiresAt(null);
      } 
      return {result: false, status: error.status};
    }
  };

  useEffect(() => {
    if (sessionId !== '' && sessionId !== null && sessionId !== undefined) {
      
      const fetchSession = async () => {
        await getSessionDetails();
      };
      fetchSession();
    }
  }, [sessionId]); 

  const login = async (email, password) => {
    try {
      const payload = {'email': email, 'password': password};
      const response = await postData('/api/v1/login', payload);
      const plan = {
        plan: response.data.plan, 
        yearly: response.data.yearly, 
        canceled: response.data.canceled
      };
      setActivePlan(plan);
      setIsAuthenticated(true);
      setSessionId(response.data.sessionId);
      const expirationUTC = new Date(response.data.expiresAt);
      const expirationDurationMS = new Date(response.data.expiresAt) - new Date();
      setExpiresAt(expirationUTC);
      setTimeout(logout, expirationDurationMS);

      return { result: true, status: response.status };
    } catch (error) {
      // alert(`Failed to login: ${error.message}`);
      setIsAuthenticated(false);
      setSessionId('');
      setExpiresAt(null);
      return {result: false, status: error.status};
    }
  };

  const logout = async () => {
    let result = false;
    try {
      await fetchData('/api/v1/logout', { sessionId });
      result = true;
    } catch (error) {
      alert(`Failed to logout: ${error.message}`);
    }
    setIsAuthenticated(false);
    setSessionId('');
    setExpiresAt(null);
    localStorage.clear();
    return result;
  };

  useEffect(() => {
    localStorage.setItem("isAuthenticated", isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => { 
    localStorage.setItem("sessionId", sessionId);
  }, [sessionId]);

  useEffect(() => { 
    localStorage.setItem("expiresAt", expiresAt);
  }, [expiresAt]);

  return (
      <AuthContext.Provider value={{ 
          isAuthenticated, 
          sessionId, 
          expiresAt, 
          login, 
          logout, 
          getSessionDetails
        }}>
        {children}
      </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
